// EmailIcon.tsx
import React from 'react';
import styled from 'styled-components';
import { MdEmail } from 'react-icons/md';

// Style the wrapper
const StyledIconWrapper = styled.div`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
  }
`;

// Type MdEmail as a proper React component
const TypedMdEmail = MdEmail as unknown as React.FC<{ size?: number | string }>;

const EmailIcon: React.FC = () => (
  <StyledIconWrapper>
    <TypedMdEmail size={24} />
  </StyledIconWrapper>
);

export default EmailIcon;
